import { lazy } from 'react';

const Login = lazy(() => import('./login'));
const SignUp = lazy(() => import('./sign-up'));
const ResetPassword = lazy(() => import('./reset-password'));
const ForgotPassword = lazy(() => import('./forgot-password'));

export { Login, SignUp, ResetPassword, ForgotPassword };
